import {Task} from '@extensions/task'
import {
  Hub,
  SystemMessageUtils,
  TimelineFilterBackend,
  UserEventsByTime
} from 'yougile-model'
import {ObjUtil} from 'yougile-util'

const between = (x: number, min: number, max: number) => x > min && x < max

const withSyntheticAddEvents = (
  task: Hub,
  events: UserEventsByTime,
  filtersForBackend: TimelineFilterBackend
) => {
  if (!task) {
    return events
  }
  const types = ObjUtil.filter(
    events,
    timestamp => events[timestamp].type === 'add'
  )
  const inRange = filtersForBackend?.createdAt?.start
    ? between(
        task.timestamp,
        filtersForBackend?.createdAt?.start,
        filtersForBackend?.createdAt?.end
      )
    : true
  const addFilter =
    filtersForBackend?.action?.includes('add') ||
    filtersForBackend?.action?.length === 0 ||
    !filtersForBackend?.action
  if (ObjUtil.isEmpty(types) && addFilter && inRange) {
    const updatedEvents: UserEventsByTime = {
      ...events,
      [task.timestamp]: {
        type: 'add',
        user: Task.creator(task)?.id,
        obj: task.id
      }
    }
    return updatedEvents
  } else {
    return events
  }
}

const withSyntheticMessageEvents = (
  task: Hub,
  events: UserEventsByTime,
  filtersForBackend: TimelineFilterBackend
) => {
  if (!task) {
    return events
  }
  const messageFilter =
    filtersForBackend?.action?.includes('message') ||
    filtersForBackend?.action?.length === 0 ||
    !filtersForBackend?.action
  const eventTypes = ObjUtil.filter(
    events,
    timestamp =>
      events[timestamp].type === 'message' || events[timestamp].type === 'file'
  )
  const inRange = filtersForBackend?.createdAt?.start
    ? between(
        task.timestamp,
        filtersForBackend?.createdAt?.start,
        filtersForBackend?.createdAt?.end
      )
    : true
  const eventTimestamps: number[] = []
  ObjUtil.forEach(eventTypes, (_timestamp, messageEvent) => {
    if (messageEvent.type === 'message') {
      eventTimestamps.push(messageEvent.time)
    }
    if (messageEvent.type === 'file') {
      eventTimestamps.push(+messageEvent.key)
    }
  })
  const updatedEvents: UserEventsByTime = events
  for (const messageTimestamp of task.chat.messages.keys()) {
    if (
      !SystemMessageUtils.isSystemMessage(
        task.chat.messages.get(messageTimestamp)
      ) &&
      !task.chat.messages.get(messageTimestamp).deleted &&
      eventTimestamps.length > 0 &&
      !eventTimestamps.includes(messageTimestamp) &&
      !task.chat.messages.get(messageTimestamp).text.includes('#file:') &&
      messageFilter &&
      inRange
    ) {
      updatedEvents[messageTimestamp] = {
        type: 'message',
        user: task.chat.messages.get(messageTimestamp).from,
        obj: task.id,
        time: messageTimestamp
      }
    }
  }
  return updatedEvents
}

export const withSyntheticEvents = (
  task: Hub,
  events: UserEventsByTime,
  filtersForBackend: TimelineFilterBackend
) => {
  if (!task) {
    return events
  }
  const withMessageEvents = withSyntheticMessageEvents(
    task,
    events,
    filtersForBackend
  )
  return withSyntheticAddEvents(task, withMessageEvents, filtersForBackend)
}
